import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

import { routingConstants } from "../Constants/routingConstants";
import { isPremiumUser } from "../utilities/utils";

const PremiumRoute = ({ children, specificAccess = false }) => {
  // specificAccess -> id client basic service -> grant access to publish job
  const { session } = useSelector((state) => state.session);

  if (
    isPremiumUser() ||
    (specificAccess && session && session[specificAccess])
  ) {
    return <div>{children}</div>;
  }

  return (
    <Navigate
      to={routingConstants.dashboard}
      state={{
        message: "Please upgrade your subscription",
      }}
    />
  );
};

export default PremiumRoute;
